import React from 'react';
import { useDispatch, useSelector } from "react-redux";
import Api from "../Api.js";
import "../assets/css/button.css";
import { REACT_APP_API_URL } from "../config.js";
import {word} from "../word.js";

const Options = ({ id, status, creator, modalShow, close }) => {
    const handleArchive = async () => {
        await Api.setArchive({id,status:true})
        close();
    };

    return (
        <div className='options'>
            <div>
                {(localStorage.getItem("profession") === "manager" && status === "end") ? (
                    <p className='options-item' onClick={handleArchive}>{word.add_archive}</p>
                ) : null}
            </div>
            {creator === `${REACT_APP_API_URL}user/${localStorage.getItem("user_id")}/` || creator.id ===  +localStorage.getItem("user_id") ? (
                <p className='options-item' onClick={modalShow}>Ջնջել</p>
            ) : null}
        </div>
    );
};

export default Options;
